const animationTagsMixin = {
    data() {
        return({
            activeTagIdx: 0,
            prevScrollPos: 0,
            disableScrollWatch: false,
            tags: ['Implantology', 'Oral surgery / Periodontics', 'Conservative', /* 'Endodontics',*/ 'Prosthodontics', 'Orthodontics', 'Hygiene', 'General / Other', 'Compare',],
            tagsHash: {
                'Implantology': 'implantology',
                'Oral surgery / Periodontics': 'oral_surgery_and_periodontics',
                'Conservative': 'compare',
                'Prosthodontics': 'prosthodontics',
                'Orthodontics': 'orthodontics',
                'Hygiene': '',
                'General / Other': '',
                'Compare': 'compare',
            },
        });
    },

    mounted() {
        const elBottom = document.getElementById('tag-container-bottom');
        elBottom.addEventListener('scroll', this.tagContainerScrollHandlerBottom);
    },

    beforeDestroy() {
        const elBottom = document.getElementById('tag-container-bottom');
        if (elBottom) elBottom.removeEventListener('scroll', this.tagContainerScrollHandlerBottom);
    },

    methods: {
        nextTag() {
            this.activeTagIdx++;
            this.setTag(this.activeTagIdx);
        },

        prevTag() {
            this.activeTagIdx--;
            this.setTag(this.activeTagIdx);
        },

        setTag(i) {
            this.activeTagIdx = i;
            const el = this.$refs['tagsBottom'][i];
            const center = document.body.clientWidth / 2;
            const rect = el.getBoundingClientRect();
            const elCenter = rect.x + (rect.width / 2);
            const container = document.getElementById('tag-container-bottom');
            this.disableScrollWatch = true;
            container.scrollTo({
                top: 0,
                left: elCenter + container.scrollLeft - center,
                behavior: "smooth",
            });
            window.setTimeout(() => {
                this.disableScrollWatch = false;
            },400);
        },

        tagContainerScrollHandlerBottom(evt) {
            if (this.disableScrollWatch) return;

            const scrollPos = evt.target.scrollLeft;
            if (Math.abs(this.prevScrollPos - scrollPos) > 5) {
                this.prevScrollPos = scrollPos;
                return;
            }
            this.setTagByScroll();

        },
        setTagByScroll() {
            const center = document.body.clientWidth / 2;
            for (let i = 0; i < this.$refs['tagsBottom'].length; i++) {
                const el = this.$refs['tagsBottom'][i];
                const tag = this.tags[i];
                const rect = el.getBoundingClientRect();
                const left = rect.x;
                const right = rect.width + rect.x;
                if (left < center && right > center) {
                    if (this.activeTagIdx !== i) {
                        this.activeTagIdx = i;
                        this.disableScrollWatch = true;
                        window.setTimeout(() => {
                            this.disableScrollWatch = false;
                        },50);
                    }
                    break;
                } else {
                    continue;
                }
            }
        },
    }
}

export default animationTagsMixin;
